const storage =  {
  app_busca_evento: {},
  app_busca_sessao: {},
  auth: false,
  pass: '',
};

export default storage;
